export default __webpack_public_path__ + "static/media/cardocorretora.9510657f.jpeg";